import React from 'react';
import { TableCell } from '@mui/material';
import { TableHeaderProps } from '../../../types';

const Header: React.FC<TableHeaderProps> = ({ 
  title, 
  subtitle, 
  colSpan = 1, 
  cellStyle 
}) => {
  const hasClassName = cellStyle && typeof cellStyle === 'object' && 'className' in cellStyle;
  const className = hasClassName ? (cellStyle as { className?: string }).className || "parent-header-text" : "parent-header-text";
  const sx = hasClassName ? undefined : cellStyle;
  
  return (
    <TableCell
      colSpan={colSpan}
      sx={{ ...sx, borderBottom: 'none' }}
      className={className}
    >
      <p className="table-header-text text-align-center">{title}</p>
      {subtitle && <p className="table-subheader-text">{subtitle}</p>}
    </TableCell>
  );
};

export default Header; 